export const LOCAL_STORAGE_KEYS = {
  USER: 'intranet_resfriar_user'
};
